<template>
  <div class="message-dialog-inner">
    {{ message }}
  </div>
</template>

<script>
import { useDialog } from './use-dialog';

export default {
  dialogify: {
    class: 'message-dialog'
  },
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { onConfirm, confirm } = useDialog();

    onConfirm(() => {
      confirm();
    });
  }
};
</script>

<style lang="scss">
.ln-dialog-wrapper.message-dialog {
  .ln-dialog {
    width: 90%;
    max-width: 360px;
    border-radius: 16px;
  }
}
</style>

<style lang="scss" scoped>
.message-dialog-inner {
  font-size: 15px;
  color: #000000;
  margin: 36px 0;
  text-align: center;
}
</style>
